import { INPUT_KEYS } from '../inputs'

export const POLICY_ACCORDION_SECTION_IDS = {
  USERS_AND_GROUPS: 'users_and_groups',
  CLOUD_APPS: 'cloud_apps',
  TARGET_RESOURCES: 'target_resources',
  NETWORKS_AND_LOCATIONS: 'networks_and_locations',
  DEVICE_PLATFORMS: 'device_platforms',
  DEVICES: 'devices',
  CLIENT_APPS: 'client_apps',
  WORKLOAD_IDENTITIES: 'workload_identities',
  RISKS: 'risks',
  AUTH_FLOWS: 'auth_flows',
  GRANT: 'grant',
  SESSION: 'session',
  ENABLEMENT: 'enablement',
}

/**
 * Accordion sections for mapped Conditional Access form fields.
 * A section is shown when at least one of its inputs is visible on the policy/form.
 */
export const POLICY_ACCORDION_SECTIONS = [
  {
    sectionId: POLICY_ACCORDION_SECTION_IDS.USERS_AND_GROUPS,
    titleMessageId: 'SECURE.USERS_AND_GROUPS',
    inputs: [
      INPUT_KEYS.includeUsers,
      INPUT_KEYS.excludeUsers,
      INPUT_KEYS.includeGroups,
      INPUT_KEYS.excludeGroups,
      INPUT_KEYS.includeRoles,
      INPUT_KEYS.excludeRoles,
      INPUT_KEYS.includeGuestsOrExternalUsers,
      INPUT_KEYS.excludeGuestsOrExternalUsers,
    ],
  },
  {
    sectionId: POLICY_ACCORDION_SECTION_IDS.CLOUD_APPS,
    titleMessageId: 'SECURE.CLOUD_APPS',
    inputs: [INPUT_KEYS.includeApplications, INPUT_KEYS.excludeApplications],
  },
  {
    sectionId: POLICY_ACCORDION_SECTION_IDS.TARGET_RESOURCES,
    titleMessageId: 'POLICY_TEMPLATES.TARGET_RESOURCES',
    inputs: [
      INPUT_KEYS.includeUserActions,
      INPUT_KEYS.includeAuthenticationContextClassReferences,
      INPUT_KEYS.applicationFilterMode,
      INPUT_KEYS.applicationFilterRule,
    ],
  },
  {
    sectionId: POLICY_ACCORDION_SECTION_IDS.NETWORKS_AND_LOCATIONS,
    titleMessageId: 'POLICY_TEMPLATES.NETWORKS_AND_LOCATIONS',
    inputs: [INPUT_KEYS.includeLocations, INPUT_KEYS.excludeLocations],
  },
  {
    sectionId: POLICY_ACCORDION_SECTION_IDS.DEVICE_PLATFORMS,
    titleMessageId: 'POLICY_TEMPLATES.DEVICE_PLATFORMS',
    inputs: [INPUT_KEYS.includePlatforms, INPUT_KEYS.excludePlatforms],
  },
  {
    sectionId: POLICY_ACCORDION_SECTION_IDS.DEVICES,
    titleMessageId: 'POLICY_TEMPLATES.DEVICES',
    inputs: [
      INPUT_KEYS.includeDevices,
      INPUT_KEYS.excludeDevices,
      INPUT_KEYS.deviceFilterMode,
      INPUT_KEYS.deviceFilterRule,
    ],
  },
  {
    sectionId: POLICY_ACCORDION_SECTION_IDS.CLIENT_APPS,
    titleMessageId: 'SECURE.CLIENT_APPS',
    inputs: [INPUT_KEYS.clientAppTypes],
  },
  {
    sectionId: POLICY_ACCORDION_SECTION_IDS.WORKLOAD_IDENTITIES,
    titleMessageId: 'POLICY_TEMPLATES.WORKLOAD_IDENTITIES',
    inputs: [
      INPUT_KEYS.includeServicePrincipals,
      INPUT_KEYS.excludeServicePrincipals,
      INPUT_KEYS.servicePrincipalFilterMode,
      INPUT_KEYS.servicePrincipalFilterRule,
    ],
  },
  {
    sectionId: POLICY_ACCORDION_SECTION_IDS.RISKS,
    titleMessageId: 'POLICY_TEMPLATES.RISKS',
    inputs: [
      INPUT_KEYS.userRiskLevels,
      INPUT_KEYS.signInRiskLevels,
      INPUT_KEYS.insiderRiskLevels,
      INPUT_KEYS.servicePrincipalRiskLevels,
      INPUT_KEYS.agentIdRiskLevels,
    ],
  },
  {
    sectionId: POLICY_ACCORDION_SECTION_IDS.AUTH_FLOWS,
    titleMessageId: 'POLICY_TEMPLATES.AUTH_FLOWS',
    inputs: [INPUT_KEYS.transferMethods],
  },
  {
    sectionId: POLICY_ACCORDION_SECTION_IDS.GRANT,
    titleMessageId: 'SECURE.GRANT',
    inputs: [
      INPUT_KEYS.builtInControls,
      INPUT_KEYS.authenticationStrength,
      INPUT_KEYS.customAuthenticationFactors,
      INPUT_KEYS.termsOfUse,
      INPUT_KEYS.grantControlsOperator,
    ],
  },
  {
    sectionId: POLICY_ACCORDION_SECTION_IDS.SESSION,
    titleMessageId: 'POLICY_TEMPLATES.SESSION',
    inputs: [
      INPUT_KEYS.signInFrequencyIsEnabled,
      INPUT_KEYS.signInFrequencyValue,
      INPUT_KEYS.signInFrequencyType,
      INPUT_KEYS.signInFrequencyInterval,
      INPUT_KEYS.signInFrequencyAuthenticationType,
      INPUT_KEYS.persistentBrowserIsEnabled,
      INPUT_KEYS.persistentBrowserMode,
      INPUT_KEYS.applicationEnforcedRestrictionsIsEnabled,
      INPUT_KEYS.cloudAppSecurityIsEnabled,
      INPUT_KEYS.cloudAppSecurityType,
      INPUT_KEYS.disableResilienceDefaults,
      INPUT_KEYS.continuousAccessEvaluationMode,
      INPUT_KEYS.secureSignInSessionIsEnabled,
      INPUT_KEYS.globalSecureAccessFilteringProfileIsEnabled,
      INPUT_KEYS.globalSecureAccessFilteringProfileId,
    ],
  },
  {
    sectionId: POLICY_ACCORDION_SECTION_IDS.ENABLEMENT,
    titleMessageId: 'SECURE.ENABLEMENT',
    inputs: [INPUT_KEYS.policyStatus],
  },
]

export const getVisiblePolicyAccordionSections = (displayInput) =>
  POLICY_ACCORDION_SECTIONS.filter((section) => section.inputs.some((input) => displayInput(input)))
